import { render, staticRenderFns } from "./AllCatalogues.vue?vue&type=template&id=6b5e322a&scoped=true&"
import script from "./AllCatalogues.vue?vue&type=script&lang=js&"
export * from "./AllCatalogues.vue?vue&type=script&lang=js&"
import style0 from "./AllCatalogues.vue?vue&type=style&index=0&id=6b5e322a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e322a",
  null
  
)

export default component.exports